import { useQuery } from "@tanstack/react-query";
import {
  getRequestContractQueryOptions,
  mapDimCodeNameToSelectOption,
} from "./getRequestContractQueryOptions";

const useGetRequestContractShipFroms = (
  cardCode: string | undefined,
  itemCode: string | undefined
) =>
  useQuery({
    ...getRequestContractQueryOptions(cardCode, itemCode),
    enabled: cardCode !== undefined && itemCode !== undefined,
    select: ({ data }) =>
      data?.ShipFromWarehouses?.map(mapDimCodeNameToSelectOption),
  });

export default useGetRequestContractShipFroms;
